import { render, staticRenderFns } from "./CommentZabbixEvent.vue?vue&type=template&id=5fda13f5&"
import script from "./CommentZabbixEvent.vue?vue&type=script&lang=js&"
export * from "./CommentZabbixEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports